import { LogLevel } from "@azure/msal-browser";
import { config } from "./js/config/config";

const clientId = config.api.clientId;
const redirect_Uri = config.api.redirect_Uri;
const authorizationEndpoint = config.api.authorizationEndpoint;
const Scope_url = config.api.scope_url;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: authorizationEndpoint,
    redirectUri: redirect_Uri, // or your preferred URL
    postLogoutRedirectUri: redirect_Uri, // important
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    Scope_url,
    // "User.Read",
    // "GroupMember.Read.All",
  ],
  prompt: "login",
};
